export type WhatsappStatusBucket = 'connected' | 'disconnected' | 'pending';
export type WhatsappProvider = 'uazapi' | 'unknown';

export type AdminWhatsappStats = {
  total: number;
  connected: number;
  disconnected: number;
  pending: number;
};

export type AdminWhatsappInstanceRow = {
  id: string;
  organizationId: string;
  organizationName: string;
  instanceName: string | null;
  phoneNumber: string | null;
  profileName: string | null;
  status: string | null;
  statusBucket: WhatsappStatusBucket;
  provider: WhatsappProvider;
  lastConnectedAt: string | null;
  lastDisconnectedAt: string | null;
  disconnectReason: string | null;
  createdAt: string;
};

export type AdminWhatsappSystemInstance = {
  configured: boolean;
  instanceName: string | null;
  connected: boolean;
  phone: string | null;
  profileName: string | null;
  qrBase64: string | null;
};

export type AdminWhatsappCommsSettings = {
  commsEnabled: boolean;
  updatedAt: string;
};

export type AdminWhatsappSendLogRow = {
  id: string;
  templateKey: string;
  toPhone: string;
  status: 'ok' | 'failed';
  errorDetail: string | null;
  sentAt: string;
  sentBy: string | null;
};

const CONNECTED = new Set(['connected', 'conectado', 'open']);
const PENDING = new Set(['qr_pending', 'connecting', 'qrcode', 'qr', 'pendente']);

export function normalizeWhatsappStatusBucket(
  status: string | null | undefined
): WhatsappStatusBucket {
  if (!status) return 'disconnected';
  const normalized = status.trim().toLowerCase();
  if (CONNECTED.has(normalized)) return 'connected';
  if (PENDING.has(normalized)) return 'pending';
  return 'disconnected';
}

/** Domain never sees raw credentials — only booleans from Edge. */
export function inferWhatsappProvider(hasUazapiToken: boolean): WhatsappProvider {
  return hasUazapiToken ? 'uazapi' : 'unknown';
}
